import classNames from 'classnames/bind';
import { Divider } from 'antd';
import dayjs from 'dayjs';
import DOMPurify from 'dompurify';
import GoToBackButton from 'components/common/GotoBackButton';
import styles from './IndividualBlog.module.css';

const cx = classNames.bind(styles);

interface IIndividualProps {
  title: string;
  displayDate: string;
  subtitle?: string;
  content?: string;
}

function IndividualBlog({
  title,
  displayDate,
  subtitle,
  content,
}: IIndividualProps) {
  const sanitizer = DOMPurify.sanitize;

  return (
    <div className={cx('main-wrapper')}>
      <section>
        <h1 className={cx('title')}>{title}</h1>
        <span className={cx('subtitle')}>{subtitle}</span>
        <span className={cx('display-date')}>
          {dayjs(displayDate).format('YYYY-MM-DD')}
        </span>
      </section>
      <Divider />
      <section className={cx('content-wrapper')}>
        <p
          dangerouslySetInnerHTML={{
            __html: sanitizer(content || '등록된 콘텐츠 내용이 없습니다.', {
              ADD_TAGS: ['iframe'],
              ADD_ATTR: [
                'width',
                'height',
                'src',
                'title',
                'frameborder',
                'allow',
                'referrerpolicy',
                'allowfullscreen',
              ],
            }),
          }}
        />
      </section>
      <GoToBackButton />
    </div>
  );
}

export default IndividualBlog;
